// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content-tab[data-v-2906e380] {\n  overflow-y: auto;\n}\n[dir] kbd[data-v-2906e380] {\n  background-color: var(--dark);\n}\n.bold[data-v-2906e380] {\n  font-weight: 600;\n}", ""]);
// Exports
module.exports = exports;
